// assets
import Load from "assets/svg/other/loading2.svg";
import Header from 'components/dashHeader';
import useInterval from 'hooks/useInterval';
//css 
import 'pages/styles/dashboard/Home.css';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { Link, useHistory } from "react-router-dom";
import { useStore } from "store";
import styled from 'styled-components';
import { get, put } from "util/axiosLib";
import { logger } from "util/logger";
import { copyToClipboard, isEmpty, makeCancelable, properCase } from "util/utils";


const rateInterval = 120000;

export default function HomeReceive() {
    const { store, localsocket } = useStore();
    const history = useHistory();
    const [pageState, setPageState] = useState('loading');
    const [invoiceData, setInvoiceData] = useState({});
    const cancelableFetch = useRef();
    const [refresh, setRefresh] = useState(1);
    const [actionInProgress, setActionInProgress] = useState(false);

    const fetchReceivable = async () => {
      try {
        const token = store.token;
        const headers = {
          authorization: `${token}`,
          "Content-Type": "application/json",
        };

        const invoiceRef = history?.location?.pathname.replace('/invoice/', '');

        if(isEmpty(invoiceRef)) {
          return setPageState('notFound');
        }

        const baseUrl = `${process.env.REACT_APP_API_ENDPOINT}/wallet/invoice/${invoiceRef}`;

        const getTransactionsReq = await get(baseUrl, headers);

        const rawTx = getTransactionsReq?.data?.data;

        setInvoiceData({...rawTx, lastFectched: new Date()});
        // await getCurrentRate();
        setPageState("ready");
      } catch (err) {
        if (err?.isAxiosError) {
          if (err?.response?.status === 401) {
            return localsocket && localsocket?.emit("LOGOUT");
          } else if (err?.response?.status === 403) {
            return setPageState("notFound");          
          } else if (err?.response?.status === 404) {
            return setPageState("notFound");
          }
        } else {
          logger("ERROR:: ", err);
        }
        setPageState("error");
        // setTransactionError(String(err))
      }
    };

     const cancelReceivable = async (tradeId) => {
       if (!tradeId) return; // show some notification here
       try {
         const baseUrl = process.env.REACT_APP_API_ENDPOINT;

         const token = store.token;
         const headers = {
           authorization: `${token}`,
           "Content-Type": "application/json",
           "Cache-Control": "no-cache",
         };

         const url = `${baseUrl}/wallet/invoice/${tradeId}/cancel`;

         setActionInProgress(true);

         await put(url, {}, headers);

         //  refetch data
         refresh();

         setActionInProgress(false);
       } catch (err) {
         setActionInProgress(false);
         logger(err);
       }
     };

     const handleCancel = async () => {
     const invoiceRef = history?.location?.pathname.replace("/invoice/", "");

     if (isEmpty(invoiceRef)) {
       return;
     }
     await cancelReceivable(invoiceRef);
     setRefresh(Math.random() * 8765)
    }

    useEffect(() => {
      cancelableFetch.current = makeCancelable(fetchReceivable());

      return () => {
        cancelableFetch.current && cancelableFetch.current.cancel();
      };
      // eslint-disable-next-line
    }, [refresh]);

        return (
          <>
            <Header />

            {/* <section className="home">
              <div className="home-container">
                
              </div>
            </section> */}
            <InvoiceCard
              invoiceData={invoiceData}
              pageState={pageState}
              setInvoiceData={setInvoiceData}
              setPageState={setPageState}
              handleCancel={handleCancel}
              actionInProgress={actionInProgress}
            />
          </>
        );
}

var NotFound = () => {
  const {store} = useStore();
  return (
    <>
      <div className="flex flex-col">
        <div className="flex justify-center">
          <h2 className="text-center">
            The page you are looking for cannot be found.
          </h2>
        </div>

        <div className="mt-8 gap-6">
          <Link to={store.isLoggedIn ? `/dashboard/wallet` : "/"} className="green bold">
            Go to Home
          </Link>
        </div>
      </div>
    </>
  );
}

export var InvoiceCard = ({
  invoiceData,
  pageState,
  setInvoiceData,
  setPageState,
  homeReceive,
  handleCancel,
  actionInProgress
}) => {
  const conversionRate = useRef();
  const { store, localsocket } = useStore();
  const [copied, setCopied] = useState(false);
  const [payScriptLoaded, setPayscriptLoaded] = useState(false);
  const [paymentData] = useState(invoiceData);
  const timerRef = useRef();

  const bitmamaPayInstance = useRef();
  const isDev = String(process.env.NODE_ENV).includes('dev');
  const isProd = String(process.env.NODE_ENV).includes('prod');
  const isStaging = (!isDev && !isProd) || String(process.env.NODE_ENV).includes('staging');

  const addr = String(invoiceData?.addressData?.address);
  const hasDollarValue = !isNaN(invoiceData?.payer?.amountInDollars);

  useEffect(() => {
    if (!payScriptLoaded) {
      const payScript = document.createElement("script");
      payScript.id = "bitmamasdk";
      payScript.type = "text/javascript";
      const newTime = new Date().toJSON();
      payScript.src =
        process.env.PUBLIC_URL +
        `/paywithbitmama${
          isDev ? "" : isStaging ? "-staging" : "-prod"
        }.js?${newTime}`;
      document.head.appendChild(payScript);
      setPayscriptLoaded(true);

      return () => {
        const bitmamasdk = document.getElementById("bitmamasdk");
        bitmamasdk && document.head.removeChild(bitmamasdk);
        // bitmamaPayInstance.current = null;
      };
    } else {
      const apiKey = "yhdhbdfhh";
      if (window.BitmamaPay) {
        const bitmamaPay = new window.BitmamaPay(apiKey);
        bitmamaPayInstance.current = bitmamaPay.init({});
      }
    }
    // eslint-disable-next-line
  }, [payScriptLoaded, window.BitmamaPay]);

  useEffect(() => {
    return () => {
          if (timerRef.current) clearInterval(timerRef.current);

    }
  }, [])

  // useEffect(() => {
  //   if (bitmamaPayInstance.current) {
  //     bitmamaPayInstance.current.pay();
  //   }
  // }, []);

  const handlePay = () => {
    console.log({yyy: bitmamaPayInstance.current})
    if (bitmamaPayInstance.current) {
      bitmamaPayInstance.current.pay({paymentData});
    }
  };

  const handleCopyToClipboard = (ev, text) => {
    if(timerRef.current) clearInterval(timerRef.current);
    if(ev) {
      ev.preventDefault();
      ev.stopPropagation();
    }
    copyToClipboard(text);
    setCopied(true);
    timerRef.current = setTimeout(() => setCopied(false), 2000);
  };

  const convertDollarToCrypto = (value, defaultV) => {
    if (conversionRate.current) {
      return Number(conversionRate.current / value);
    } else return defaultV || value;
  };

  const calcPaymentAmount = useMemo(() => {
    let amountInCrypto = Number(
      Number(invoiceData?.payer?.amountReceivable ?? 0).toFixed(8)
    );
    let amountInDollars = invoiceData?.payer?.amountInDollars;
    if (amountInDollars) return convertDollarToCrypto(amountInDollars, amountInCrypto);
    return amountInCrypto;
    // eslint-disable-next-line
  }, [invoiceData?.payer?.amountInDollars, invoiceData?.payer?.amountReceivable, conversionRate.current]);

  // console.log({realTimeAmount: calcPaymentAmount, cov: conversionRate.current})

  const getCurrentRate = async () => {
    if(!hasDollarValue) return;
    const token = store?.token;
    const headers = {
      authorization: `${token}`,
      "Content-Type": "application/json",
    };

    let coin = invoiceData?.addressData?.coin;

    let amountInDollars = invoiceData?.payer?.amountInDollars;
    if (!amountInDollars) return;
    try {
      const getCurrentRateUrl = `${process.env.REACT_APP_API_ENDPOINT}/wallet/rate/exchangeRate?ticker=${coin}usd`;
      const getExchangeReq = await get(getCurrentRateUrl, headers);
      const currentRate = getExchangeReq?.data?.data?.exchangeRate;

      conversionRate.current = !isNaN(currentRate.buy) ? Number(currentRate.buy) : 0;
      if (!isEmpty(invoiceData))
        setInvoiceData({ ...invoiceData, lastFectched: new Date() });
    } catch (err) {
      console.log("[@getCurrentRate]: ", err);
      if (err?.isAxiosError) {
        if (err?.response?.status === 401) {
          return localsocket && localsocket?.emit("LOGOUT");
        } else if (err?.response?.status === 403) {
          // return setPageState("notFound");
        } else if (err?.response?.status === 404) {
          // return setPageState("notFound");
        }
      } else {
        logger("ERROR:: ", err);
      }
    }
  };

  useInterval(getCurrentRate, rateInterval);

  return (
    <StyledDiv>
      <div id="invoiceholder" className={`${homeReceive ? "homeReceive" : ""}`}>
        {!homeReceive && <div id="headerimage" />}
        <div
          id="invoice"
          className={`effect2 ${homeReceive ? "homeReceive" : ""} ${
            ["notFound", "loading", "error"].includes(pageState)
              ? "no-content"
              : ""
          }`}
        >
          {pageState === "loading" ? (
            <div className="grid-center">
              <div className="loading-a" id="load">
                <img src={Load} alt="loading" />
              </div>
            </div>
          ) : pageState === "notFound" ? (
            <NotFound />
          ) : (
            <>
              <div id="invoice-top">
                <div className="logo" />
                <div className="info">
                  <h2>{` ${properCase(
                    invoiceData?.payee?.lastName
                  )} ${properCase(invoiceData?.payee?.firstName)}`}</h2>
                  <p>
                    {String(invoiceData?.payee?.email).toLowerCase()} <br />
                    {/* 000-111-5555 */}
                  </p>
                </div>
                {/*End Info*/}
                <div className="title">
                  <h1 style={{ textAlign: "right" }}>Invoice</h1>
                  <p>
                    Issued:{" "}
                    {String(invoiceData?.payer?.timeline?.createdAt)
                      .split(":")[0]
                      .slice(0, -2)
                      .trim()}
                    <br />
                    Payment Due:{" "}
                    {String(invoiceData?.payer?.timeline?.dueAt)
                      .split(":")[0]
                      .slice(0, -2)
                      .trim()}
                  </p>
                </div>
                {/*End Title*/}
              </div>
              {/*End InvoiceTop*/}
              <div id="invoice-mid">
                <div className="clientlogo" />
                <div className="info">
                  <h2>{`${invoiceData?.payer?.user?.lastName} ${invoiceData?.payer?.user?.firstName}`}</h2>
                  <p>
                    {`${invoiceData?.payer?.user?.email}`}
                    <br />
                    {invoiceData?.payer?.user?.phoneNumber}
                    <br />
                  </p>
                </div>
                <div id="project">
                  <h2>Description</h2>
                  <p>
                    {invoiceData?.payer?.user?.description ??
                      "No description available"}
                  </p>
                </div>
              </div>
              {/*End Invoice Mid*/}
              <div
                id="invoice-bot"
                className={invoiceData?.receivableState ?? ""}
              >
                <table
                  className={`invoice-tx--table ${
                    invoiceData?.receivableState ?? ""
                  }`}
                >
                  <tbody>
                    <tr>
                      <td style={{ height: "35px" }} />
                    </tr>
                    <tr>
                      <td
                        colSpan={2}
                        style={{
                          padding: "10px 20px",
                        }}
                      >
                        <p
                          style={{
                            fontSize: "14px",
                            margin: "0 0 8px 0",
                          }}
                        >
                          <span
                            style={{
                              fontWeight: "bold",
                              display: "inline-block",
                              minWidth: "150px",
                            }}
                          >
                            Payment status
                          </span>
                          <b
                            style={{
                              fontWeight: "normal",
                              margin: 0,
                            }}
                            className={`paystate-${
                              invoiceData?.receivableState ?? ""
                            }`}
                          >
                            {invoiceData?.receivableState === "open"
                              ? "Pending"
                              : properCase(invoiceData?.receivableState)}
                          </b>
                        </p>
                        <p
                          style={{
                            fontSize: "14px",
                            margin: "0 0 8px 0",
                          }}
                        >
                          <span
                            style={{
                              fontWeight: "bold",
                              display: "inline-block",
                              minWidth: "146px",
                            }}
                          >
                            Invoice Ref
                          </span>{" "}
                          {invoiceData?.ref}
                        </p>
                        <p style={{ fontSize: "14px", margin: "0 0 8px 0" }}>
                          <span
                            style={{
                              fontWeight: "bold",
                              display: "inline-block",
                              minWidth: "146px",
                            }}
                          >
                            Payment amount
                          </span>{" "}
                          {`${
                            true ? calcPaymentAmount : calcPaymentAmount
                          } ${String(
                            invoiceData?.addressData?.coin
                          ).toUpperCase()} `}
                          {hasDollarValue
                            ? ` - ${Number(
                                Number(
                                  invoiceData?.payer?.amountInDollars ?? 0
                                ).toFixed(2)
                              )} USD`
                            : ""}
                        </p>
                        <p style={{ fontSize: "14px" }}>
                          <span
                            style={{
                              fontWeight: "bold",
                              display: "inline-block",
                              minWidth: "146px",
                            }}
                          >
                            Payment Address
                          </span>
                          <>
                            <span>
                              {`${addr.slice(0, 4)}...${addr.slice(
                                addr?.length - 5
                              )}`}
                              {!copied && (
                                <span
                                  className="ml-8"
                                  style={{ display: "unset" }}
                                >
                                  <button
                                    className="copyTc"
                                    onClick={(e) =>
                                      handleCopyToClipboard(e, String(addr))
                                    }
                                  >
                                    Copy
                                  </button>
                                </span>
                              )}
                              {copied && (
                                <span
                                  className="ml-8"
                                  style={{ display: "unset" }}
                                >
                                  <button
                                    className="copiedTc"
                                    onClick={(e) => e.preventDefault()}
                                  >
                                    Copied
                                  </button>
                                </span>
                              )}
                            </span>
                          </>
                        </p>
                      </td>
                    </tr>
                    <tr>
                      <td style={{ height: "35px" }} />
                    </tr>
                  </tbody>
                </table>

                {false && (
                  <div id="table">
                    <table>
                      <tbody>
                        <tr className="tabletitle">
                          <td className="item">
                            <h2>Item Description</h2>
                          </td>
                          <td className="Hours">
                            <h2>Hours</h2>
                          </td>
                          <td className="Rate">
                            <h2>Rate</h2>
                          </td>
                          <td className="subtotal">
                            <h2>Sub-total</h2>
                          </td>
                        </tr>
                        <tr className="service">
                          <td className="tableitem">
                            <p className="itemtext">Communication</p>
                          </td>
                          <td className="tableitem">
                            <p className="itemtext">5</p>
                          </td>
                          <td className="tableitem">
                            <p className="itemtext">$75</p>
                          </td>
                          <td className="tableitem">
                            <p className="itemtext">$375.00</p>
                          </td>
                        </tr>
                        <tr className="service">
                          <td className="tableitem">
                            <p className="itemtext">Asset Gathering</p>
                          </td>
                          <td className="tableitem">
                            <p className="itemtext">3</p>
                          </td>
                          <td className="tableitem">
                            <p className="itemtext">$75</p>
                          </td>
                          <td className="tableitem">
                            <p className="itemtext">$225.00</p>
                          </td>
                        </tr>
                        <tr className="service">
                          <td className="tableitem">
                            <p className="itemtext">Design Development</p>
                          </td>
                          <td className="tableitem">
                            <p className="itemtext">5</p>
                          </td>
                          <td className="tableitem">
                            <p className="itemtext">$75</p>
                          </td>
                          <td className="tableitem">
                            <p className="itemtext">$375.00</p>
                          </td>
                        </tr>
                        <tr className="service">
                          <td className="tableitem">
                            <p className="itemtext">Animation</p>
                          </td>
                          <td className="tableitem">
                            <p className="itemtext">20</p>
                          </td>
                          <td className="tableitem">
                            <p className="itemtext">$75</p>
                          </td>
                          <td className="tableitem">
                            <p className="itemtext">$1,500.00</p>
                          </td>
                        </tr>
                        <tr className="service">
                          <td className="tableitem">
                            <p className="itemtext">Animation Revisions</p>
                          </td>
                          <td className="tableitem">
                            <p className="itemtext">10</p>
                          </td>
                          <td className="tableitem">
                            <p className="itemtext">$75</p>
                          </td>
                          <td className="tableitem">
                            <p className="itemtext">$750.00</p>
                          </td>
                        </tr>
                        <tr className="service">
                          <td className="tableitem">
                            <p className="itemtext" />
                          </td>
                          <td className="tableitem">
                            <p className="itemtext">HST</p>
                          </td>
                          <td className="tableitem">
                            <p className="itemtext">13%</p>
                          </td>
                          <td className="tableitem">
                            <p className="itemtext">$419.25</p>
                          </td>
                        </tr>
                        <tr className="tabletitle">
                          <td />
                          <td />
                          <td className="Rate">
                            <h2>Total</h2>
                          </td>
                          <td className="payment">
                            <h2>$3,644.25</h2>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                )}
                {/*End Table*/}
                {store &&
                store?.isSignedIn &&
                store?.token &&
                store?.userData?.userId === invoiceData?.payee?.userId ? (
                  invoiceData?.receivableState === "open" ? (
                    <form
                      method="post"
                      target="_top"
                      onSubmit={(e) => {
                        if (actionInProgress) return;
                        e.preventDefault();
                        handleCancel && handleCancel();
                      }}
                    >
                      <button className="pwtbmm cancel-invoice">
                        Cancel Invoice
                      </button>
                    </form>
                  ) : null
                ) : (
                  invoiceData?.receivableState === "open" ? <form
                    method="post"
                    target="_top"
                    onSubmit={(e) => {
                      if (actionInProgress) return;
                      e.preventDefault();
                      handlePay && handlePay();
                    }}
                  >
                    <button
                      className="pwtbmm"
                      disabled={Boolean(actionInProgress)}
                    >
                      Pay with Bitmama
                    </button>
                  </form> : null
                )}
                <div id="legalcopy">
                  {!homeReceive && (
                    <p className="legal">
                      <strong>Thank you for your business!</strong>&nbsp; <br />
                      <br />
                      Payment is expected within{" "}
                      {`${invoiceData?.payer?.timeline?.duration} ${invoiceData?.payer?.timeline?.durationUnit} `}
                      of issuance of this invoice. <br />
                      Please process this invoice before{" "}
                      {String(invoiceData?.payer?.timeline?.dueAt)
                        .split(":")[0]
                        .slice(0, -2)
                        .trim()}
                      .
                    </p>
                  )}
                </div>
              </div>
              {/*End InvoiceBot*/}
            </>
          )}
        </div>
        {/*End Invoice*/}
      </div>
    </StyledDiv>
  );
};

var StyledDiv = styled.div`
  .copyTc {
    background: inherit;
    &::hover {
      background-color: #1e1e1e;
    }
    opacity: 0.8;
    color: blue;
    border: none;
    font-weight: 600;
    padding: 4px 8px;
  }
  .copiedTc {
    opacity: 0.8;
    color: blue;
    font-weight: 600;
    padding: 4px 8px;
  }
  .paystate {
    &-cancelled,
    &-timeout,
    &-failed,
    &-cancelled,
    &-reversed {
      color: #ed2e7e;
    }
    &-going {
      color: steeleblue;
    }
    &-open {
      color: orange;
    }
    &-paid {
      color: green;
    }
  }
  .pwtbmm {
    padding: 8px 1rem;
    border-radius: 40px;
    background-color: green;
    outline: none;
    color: white;
    border: none;

    &.cancel-invoice {
      background-color: #ed2e7e;
    }
  }
  .grid-center {
    width: 100%;
    postion: relative;
    display: grid;
    place-content: center;
    .loading-a {
      width: 100%;
      left: 0;
      position: relative;
      height: 4em;
      padding: 1em;
      font-size: 0.9em;
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 3;

      &.actioning {
        opacity: 0.75;
        padding: unset;
        height: unset;
      }
    }
  }
  .invoice-tx--table {
    max-width: 670px;
    margin: 0px auto 10px;
    background-color: #fff;
    padding-top: unset;
    border-radius: 3px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
    border-top: solid 10px green;

    &.cancelled,
    &.timeout,
    &.failed,
    &.cancelled,
    &.reversed {
      border-color: #ed2e7e;
    }
    &.going {
      border-color: steeleblue;
    }
    &.open {
      border-color: orange;
    }
    &.paid {
      border-color: green;
    }
  }
  .home-container {
    margin-left: unset;
    .invoice-content {
      display: grid;
      place-content: center;
    }
  }

  ::selection {
    background: #f31544;
    color: #fff;
  }
  ::moz-selection {
    background: #f31544;
    color: #fff;
  }
  h1 {
    font-size: 1.5em;
    color: #222;
  }
  h2 {
    font-size: 0.9em;
  }
  h3 {
    font-size: 1.2em;
    font-weight: 300;
    line-height: 2em;
  }
  p {
    font-size: 0.7em;
    color: #666;
    line-height: 1.2em;
  }

  #invoiceholder {
    width: 100%;
    hieght: 100%;
    padding-top: 50px;
    &.homeReceive {
      padding-top: 0px;
    }
  }
  #headerimage {
    z-index: -1;
    position: relative;
    top: -50px;
    height: 350px;
    background-image: url("/images/invoicebg.jpg");

    -webkit-box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.15),
      inset 0 -2px 4px rgba(0, 0, 0, 0.15);
    -moz-box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.15),
      inset 0 -2px 4px rgba(0, 0, 0, 0.15);
    box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.15),
      inset 0 -2px 4px rgba(0, 0, 0, 0.15);
    overflow: hidden;
    background-attachment: fixed;
    background-size: 1920px 80%;
    background-position: 50% -90%;
  }
  #invoice {
    position: relative;
    top: -290px;
    margin: 0 auto;
    width: 700px;
    background: #fff;
    &.homeReceive {
      width: 100%;
      top: unset;
    }
    &.no-content {
      top: -50%;
      text-align: center;
    }
  }

  [id*="invoice-"] {
    /* Targets all id with 'col-' */
    border-bottom: 1px solid #eee;
    padding: 30px;
  }

  #invoice-top {
    min-height: 120px;
  }
  #invoice-mid {
    min-height: 120px;
  }
  #invoice-bot {
    min-height: 250px;
  }

  .logo {
    float: left;
    height: 60px;
    width: 60px;
    background: url(/images/logo1.png) no-repeat;
    background-size: 60px 60px;
  }
  .clientlogo {
    float: left;
    height: 60px;
    width: 60px;
    background: url(/images/client.jpg) no-repeat;
    background-size: 60px 60px;
    border-radius: 50px;
  }
  .info {
    display: block;
    float: left;
    margin-left: 20px;
  }
  .title {
    float: right;
    font-size: 0.75rem;
  }
  .title p {
    text-align: right;
  }
  #project {
    margin-left: 52%;
  }
  table {
    width: 100%;
    border-collapse: collapse;
  }
  td {
    padding: 15px 0 5px 15px;
  }
  .tabletitle {
    padding: 5px;
    background: #eee;
  }
  .service {
    border: 1px solid #eee;
  }
  .item {
    width: 50%;
  }
  .itemtext {
    font-size: 0.9em;
  }

  #legalcopy {
    margin-top: 30px;
  }
  form {
    float: right;
    margin-top: 30px;
    text-align: right;
  }

  .effect2 {
    position: relative;
  }
  .effect2:before,
  .effect2:after {
    z-index: -1;
    position: absolute;
    content: "";
    bottom: 15px;
    left: 10px;
    width: 50%;
    top: 80%;
    max-width: 300px;
    background: #777;
    -webkit-box-shadow: 0 15px 10px #777;
    -moz-box-shadow: 0 15px 10px #777;
    box-shadow: 0 15px 10px #777;
    -webkit-transform: rotate(-3deg);
    -moz-transform: rotate(-3deg);
    -o-transform: rotate(-3deg);
    -ms-transform: rotate(-3deg);
    transform: rotate(-3deg);
  }
  .effect2:after {
    -webkit-transform: rotate(3deg);
    -moz-transform: rotate(3deg);
    -o-transform: rotate(3deg);
    -ms-transform: rotate(3deg);
    transform: rotate(3deg);
    right: 10px;
    left: auto;
  }

  .legal {
    width: 70%;
  }
`;


